module.exports = __webpack_public_path__ + "static/media/polaris.532f156d.png";